import styled from "styled-components";

export const ModalVerificaOsContainer = styled.div`
  background-color: var(--color-white);
  padding: 20px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 0 0 4px 4px;
`;
export const ModalVerificaOsBody = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 40px 40px 40px;
  width: 640px;
  span {
    font-size: 18px;
    color: var(--color-latex10);
  }
  .ModalVerificaOs-descripcion {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
  }
  .ModalVerificaOs-bold{
    font-weight: bold;
  }
`;
export const ModalVerificaOsFooter = styled.div`
  font-size: 18px;
  .ModalVerificaOs-btn {
    padding: 0 42px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    cursor: pointer;
  }
  .ModalVerificaOs-latex10 {
    background-color: var(--color-latex10);
    color: var(--color-white);
  }
  .ModalVerificaOs-white {
    background-color: var(--color-white);
    color: var(--color-latex10);
    box-shadow: inset 0 0 0 2px var(--color-latex10);
  }
  display: flex;
  gap: 8px;
`;
